import { Box, Heading, Text } from "src/components/UI";

const DirectDebitInformation = () => {
  return (
    <Box
      width={["auto", "100%"]}
      padding={["16px", "16px"]}
      gap={["4px", "16px"]}
      backgroundColor={["#F4F4F4"]}
      margin={["0 16px 25px 16px", "8px 0 16px"]}
      borderRadius={["16px"]}
    >
      <Heading
        fontFamily="Roboto, sans-serif"
        fontSize={["14px", "20px"]}
        fontWeight={["700", "700"]}
        lineHeight={["20px", "24px"]}
        letterSpacing={["0.16px", "-0.16px"]}
        textAlign={["left", "left"]}
        color={["#404040", "#383838"]}
      >
        Penting Untuk Kamu Ketahui
      </Heading>
      <Box
        as="ul"
        listStyle="initial"
        fontFamily="Roboto, sans-serif"
        paddingLeft={["16px"]}
        fontSize={["13px", "16px"]}
        fontWeight={["500", "400"]}
        lineHeight={["20px", "24px"]}
        letterSpacing={["0.24px", "0px"]}
        color={["#676767"]}
        margin={["unset", "0 auto"]}
      >
        <li>
          <Text>
            Pendebitan otomatis dilakukan 3 hari sebelum tanggal jatuh tempo.
          </Text>
        </li>
        <li>
          <Text>
            Pendebitan otomatis dilakukan pada pukul 10.00 dan/atau 19.00.
          </Text>
        </li>
        <li>
          <Text>
            Jika gagal, pendebitan otomatis dilakukan 2 hari sebelum tanggal
            jatuh tempo pada pukul 10.00.
          </Text>
        </li>
        <li>
          <Text>
            Jika masih gagal, pendebitan otomatis akan dilakukan di tanggal
            jatuh tempo pada pukul 10.00.
          </Text>
        </li>
      </Box>
    </Box>
  );
};

export default DirectDebitInformation;
